import { FacebookIcon, InstagramIcon, YoutubeIcon } from "./SocialIcons";
import "./SocialLinks.css";

type SocialItem = {
  href: string;
  label: string;
};

type SocialLinksProps = {
  items: readonly SocialItem[];
};

export function SocialLinks({ items }: SocialLinksProps) {
  function getIcon(href: string) {
    if (href.includes("facebook.com")) return <FacebookIcon className="social-icon" />;
    if (href.includes("instagram.com")) return <InstagramIcon className="social-icon" />;
    if (href.includes("youtube.com")) return <YoutubeIcon className="social-icon" />;
    return null;
  }

  return (
    <section className="social-links" aria-label="Redes sociais">
      {items.map(item => (
        <a
          key={item.href}
          href={item.href}
          target="_blank"
          rel="noreferrer"
          aria-label={item.label}
          className="social-link"
        >
          {getIcon(item.href) || item.label}
        </a>
      ))}
    </section>
  );
}
